module.exports = __webpack_public_path__ + "img/phone.15659521.webp";